import React, { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ModalCreditCard } from "./ModalCreditCard";
import { FaCopy, FaLink } from "react-icons/fa";
import { CreditCardPreview } from "./render";
import { toPng } from "html-to-image";
import { Link } from "react-router-dom";

export const CreditCard = () => {
  const [copied, setCopied] = useState(false);

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const [environment, setEnvironment] = useState(
    queryParams.get("environment") || "DEV"
  );
  const [allowFlip, setAllowFlip] = useState(
    queryParams.get("allowFlip") || "Y"
  );

  const [brand, setBrand] = useState(queryParams.get("brand") || "");
  const [brandPosition, setBrandPosition] = useState(
    queryParams.get("brandPosition") || "top-right"
  );

  const [bankName, setBankName] = useState(queryParams.get("bankName") || "");
  const [bankLogo, setBankLogo] = useState(queryParams.get("bankLogo") || "");
  const [bankLogoPosition, setBankLogoPosition] = useState(
    queryParams.get("bankLogoPosition") || "bottom-right"
  );
  const [cardImage, setCardImage] = useState(
    queryParams.get("cardImage") || ""
  );

  const [cardNumber, setCardNumber] = useState(
    queryParams.get("cardNumber") || "**** **** **** 3456"
  );
  const [cardHolder, setCardHolder] = useState(
    queryParams.get("cardHolder") || "John Doe"
  );
  const [expires, setExpires] = useState(queryParams.get("expires") || "12/24");
  const [cvv, setCvv] = useState(queryParams.get("cvv") || "123");
  const [lang, setLang] = useState(queryParams.get("lang") || "en");

  const [colorBackground, setColorBackground] = useState(
    queryParams.get("colorBackground") || "#FFFFFF"
  );
  const [colorPrimary, setColorPrimary] = useState(
    queryParams.get("colorPrimary") || "#0066FF"
  );
  const [colorSecondary, setColorSecondary] = useState(
    queryParams.get("colorSecondary") || "#01087A"
  );
  const [colorFont, setColorFont] = useState(
    queryParams.get("colorFont") || "#FFFFFF"
  );
  const [fontFamily, setFontFamily] = useState(
    queryParams.get("fontFamily") || "Arial"
  );
//console.log(queryParams.getAll("colorPrimary"));
  const linkToCopy =
    process.env.REACT_APP_FRONT_URL +
    "/credit-card?na=1" +
    "&environment=PROD" +
    "&allowFlip=" +
    encodeURIComponent(allowFlip.toString()) +
    "&brand=" +
    encodeURIComponent(brand) +
    "&brandPosition=" +
    encodeURIComponent(brandPosition) +
    "&bankName=" +
    encodeURIComponent(bankName) +
    "&bankLogo=" +
    encodeURIComponent(bankLogo) +
    "&bankLogoPosition=" +
    encodeURIComponent(bankLogoPosition) +
    "&cardNumber=" +
    encodeURIComponent(cardNumber) +
    "&cardHolder=" +
    encodeURIComponent(cardHolder) +
    "&expires=" +
    encodeURIComponent(expires) +
    "&cvv=" +
    encodeURIComponent(cvv) +
    "&colorBackground=" +
    encodeURIComponent(colorBackground) +
    "&colorPrimary=" +
    encodeURIComponent(colorPrimary) +
    "&colorSecondary=" +
    encodeURIComponent(colorSecondary) +
    "&colorFont=" +
    encodeURIComponent(colorFont) +
    "&fontFamily=" +
    encodeURIComponent(fontFamily) +
    "&cardImage=" +
    encodeURIComponent(cardImage) +
    "&colorBackground=" +
    encodeURIComponent(colorBackground) +
    "&lang=" +
    encodeURIComponent(lang);

  const handleCopy = () => {
    navigator.clipboard.writeText(linkToCopy);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div
        className="flex flex-col items-center justify-center"
        style={{ width: "100%", backgroundColor: colorBackground }}
      >
        {environment === "DEV" && (
          <>
            <h1 style={{ fontSize: 40, fontWeight: "bold" }}>
              Credit Card Component
            </h1>
            <br />
            <br />
            <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
            <br />

            <h3 className="text-md font-semibold mb-3 mt-10">
              Card Information
            </h3>
            <div className="flex flex-wrap items-start justify-start gap-4 w-full">
              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">cardNumber</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Numero de la tarjeta (16 digitos)
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setCardNumber(e.target.value)}
                      value={cardNumber}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">cardHolder</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Titular de la tarjeta
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setCardHolder(e.target.value)}
                      value={cardHolder}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">expires</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Expiracion de la tarjeta
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setExpires(e.target.value)}
                      value={expires}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">cvv</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Codigo de Verificacion
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setCvv(e.target.value)}
                      value={cvv}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">lang</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Idioma de los textos
                    <br />
                    <select
                      className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      onChange={(e) => setLang(e.target.value)}
                      value={lang}
                    >
                      <option value="en">en</option>
                      <option value="es">es</option>
                      <option value="pt">pt</option>
                    </select>
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-md font-semibold mb-3 mt-10">Card Options</h3>
            <div className="flex flex-wrap items-start justify-start gap-4 w-full">
              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">allowFlip</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Habilita o no la posibilidad de Girar la tarjeta <br /> Para
                    utilizar en el BO sin mostrar el CVV
                    <br />
                    <select
                      className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      onChange={(e) => setAllowFlip(e.target.value)}
                      value={allowFlip}
                    >
                      <option value="Y">Y</option>
                      <option value="N">N</option>
                    </select>
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">brand</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Marca de la tarjeta, puede ser VISA, MASTER o VACIA
                    <br />
                    <select
                      className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      onChange={(e) => setBrand(e.target.value)}
                      value={brand}
                    >
                      <option value=""></option>
                      <option value="VISA">VISA</option>
                      <option value="MASTER">MASTER</option>
                    </select>
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">brandPosition</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Ubicacion del logo de la tarjeta
                    <br />
                    <br />
                    <select
                      className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      onChange={(e) => setBrandPosition(e.target.value)}
                      value={brandPosition}
                    >
                      <option value="top-right">top-right</option>
                      <option value="top-left">top-left</option>
                      <option value="bottom-left">bottom-left</option>
                      <option value="bottom-right">bottom-right</option>
                    </select>
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-md font-semibold mb-3 mt-10">Scene</h3>
            <div className="flex flex-wrap items-start justify-start gap-4 w-full">
              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">colorBackground</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Color del fondo del html area
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setColorBackground(e.target.value)}
                      value={colorBackground}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">colorPrimary</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Color Primario de la tarjeta
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setColorPrimary(e.target.value)}
                      value={colorPrimary}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">colorSecondary</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Color Secundario
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setColorSecondary(e.target.value)}
                      value={colorSecondary}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">colorFont</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Color Fuente
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setColorFont(e.target.value)}
                      value={colorFont}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">fontFamily</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Tipografia
                    <br />
                    <select
                      className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      onChange={(e) => setFontFamily(e.target.value)}
                      value={fontFamily}
                    >
                      <option value="Arial, sans-serif">
                        Arial, sans-serif
                      </option>
                      <option value="Courier New, monospace">
                        Courier New, monospace
                      </option>
                      <option value="Helvetica, sans-serif">
                        Helvetica, sans-serif
                      </option>
                      <option value="Verdana, sans-serif">
                        Verdana, sans-serif
                      </option>
                      <option value="Tahoma, sans-serif">
                        Tahoma, sans-serif
                      </option>
                      <option value="Trebuchet MS, sans-serif">
                        Trebuchet MS, sans-serif
                      </option>
                      <option value="Open Sans, sans-serif">
                        Open Sans, sans-serif
                      </option>
                      <option value="Roboto, sans-serif">
                        Roboto, sans-serif
                      </option>
                    </select>
                  </p>
                </div>
              </div>
            </div>

            <h3 className="text-md font-semibold mb-3 mt-10">Bank Options</h3>
            <div className="flex flex-wrap items-start justify-start gap-4 w-full">
              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">bankName</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Nombre del Banco
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setBankName(e.target.value)}
                      value={bankName}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">bankLogo</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Url del Logo del banco (Puede estar vacia)
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setBankLogo(e.target.value)}
                      value={bankLogo}
                    />
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: 400 }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">bankLogoPosition</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Ubicacion del logo del banco
                    <br />
                    <select
                      className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                      onChange={(e) => setBankLogoPosition(e.target.value)}
                      value={bankLogoPosition}
                    >
                      <option value="top-right">top-right</option>
                      <option value="top-left">top-left</option>
                      <option value="bottom-left">bottom-left</option>
                      <option value="bottom-right">bottom-right</option>
                    </select>
                  </p>
                </div>
              </div>

              <div
                className="h-auto rounded overflow-hidden  bg-white"
                style={{ width: "30%" }}
              >
                <div className="h-full px-6 py-4 flex flex-col">
                  <div className="font-bold text-xl mb-2">cardImage</div>
                  <p className="text-gray-700 text-base flex-grow">
                    Url de un arte de tarjeta personalizado (Puede estar vacia)
                    <br />
                    <input
                      type="text"
                      className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                      onChange={(e) => setCardImage(e.target.value)}
                      value={cardImage}
                    />
                  </p>
                </div>
              </div>
            </div>
            <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>

            <br />
            <br />
          </>
        )}

        <CreditCardPreview
          allowFlip={allowFlip}
          brand={brand}
          brandPosition={brandPosition}
          bankName={bankName}
          bankLogo={bankLogo}
          bankLogoPosition={bankLogoPosition}
          cardNumber={cardNumber}
          cardHolder={cardHolder}
          expires={expires}
          cvv={cvv}
          colorPrimary={colorPrimary!==undefined && colorPrimary!='' ? '#' + colorPrimary.replace("#", "") : colorPrimary}
          colorSecondary={colorSecondary!==undefined && colorSecondary!='' ? '#' + colorSecondary.replace("#", "") : colorSecondary}
          colorFont={colorFont!==undefined && colorFont!='' ? '#' + colorFont.replace("#", "") : colorFont}
          colorBackground={colorBackground!==undefined && colorBackground!='' ? '#' + colorBackground.replace("#", "") : colorBackground}
          cardImage={cardImage}
          fontFamily={fontFamily}
          environment={environment}
          handleCopy={handleCopy}
          copied={copied}
          lang={lang}
        />

        {environment === "DEV" && (
          <div>
            <br />
            <br />
            <h3 className="text-lg font-semibold mb-3">ACTIONS</h3>
            <div className="flex items-center mb-5">
              <button
                onClick={handleCopy}
                className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
              >
                <FaCopy className="mr-2" />
                {copied ? "Copied!" : "Copy Link"}
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
